import { ColumnDef } from "@tanstack/react-table";
import { TableRenderUtils } from "../../components/Table/TableRenderUtils";
import { RightIssue, RightsIntersectionRecord } from "../../api/useRightsApi";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";

export function rightsIssuesColumnsDefinitionShort(t: any, onClick: (share: number, territory_shares: number[], index: number) => void): Array<ColumnDef<RightIssue, any>> {
  return [
    {
      id: "ReleaseID",
      header: `${t("rights_intersections.release_id")}`,
      size: 100,
      enableSorting: false,
      accessorFn: (value) => value.release_id,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "ExternalID",
      header: `${t("rights_intersections.external_id")}`,
      size: 100,
      enableSorting: false,
      accessorFn: (value) => value.external_id,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "CodeISRC",
      header: `${t("isrc")}`,
      size: 100,
      enableSorting: false,
      accessorFn: (value) => value.code_isrc,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Title",
      header: `${t("name")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.title,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Artist",
      header: `${t("artist")}`,
      size: 150,
      enableSorting: false,
      accessorFn: (value) => value.artist_title,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ?? "—", {
          className: "text-sm"
        });
      }
    },
    {
      id: "Share",
      header: () => <div className={"w-100 text-right"}>{t("share")}</div>,
      size: 100,
      enableSorting: false,
      accessorFn: (value) => value,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(<div
          className={"hover:cursor-pointer"}
          onClick={() => onClick(value.getValue().share, value.getValue().territory_shares, value.row.index)}>
          {
            value.getValue().share ? value.getValue().share + "%" : "—"
          }
          <FontAwesomeIcon className={"ml-2 text-gray-400"} icon={faEdit}/>
        </div>, {
          className: "text-sm text-right"
        });
      }
    },
    {
      id: "CommonShare",
      header: () => <div className={"w-100 text-right"}>{t("issues.common_share")}</div>,
      size: 130,
      enableSorting: false,
      accessorFn: (value) => value.common_share,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(value.getValue() ? value.getValue() + "%" : "—", {
          className: "text-sm text-right"
        });
      }
    },
    {
      id: "Contractors",
      header: () => <div className={"w-100 text-right"}>{t("issues.contractors")}</div>,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.contractors_list,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(<div className={"whitespace-pre-line"}>
          {value.getValue().join("\n")}
        </div>, {
          className: "text-sm text-right"
        });
      }
    }
  ];
}
